import routes from '@mnd-apps/publish/routes';
import { GREY_1000, SIZING_5 } from '@mnd-frontend/ui/shared/tokens';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Wrapper = styled.div`
  align-items: center;
  animation: ${fadeIn} 1s ease forwards;
  display: flex;
  height: 100vh;
  justify-content: center;
  opacity: 0;
  text-align: center;
  width: 100%;
`;

const Headline = styled.h1`
  color: ${GREY_1000};
  font-size: ${SIZING_5};
  font-weight: 300;
`;

const NavigatorScreen = ({ pressroomId }: { pressroomId: string }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(routes.dashboard({ pressroomId }));
    }, 2500);

    return () => {
      clearTimeout(timer);
    };
  }, [navigate, pressroomId]);

  return (
    <Wrapper>
      <Headline>{t('onboarding_trial_navigator_title') + ' 🎉'}</Headline>
    </Wrapper>
  );
};

export default NavigatorScreen;
